import { lazy } from 'react';

import {
  CommentOutlined,
  DashboardOutlined,
  EnvironmentOutlined,
  MobileOutlined,
  PictureOutlined,
  WarningOutlined,
} from '@ant-design/icons';

import { ReactComponent as EmployeesIcon } from 'assets/icons/employees.svg';
import { ReactComponent as MyReviewsIcon } from 'assets/icons/myReviews.svg';
import { ReactComponent as ReportsIcon } from 'assets/icons/reports.svg';

const Dashboard = lazy(() => import('modules/dashboard'));
const Reviews = lazy(() => import('modules/reviews'));
const Users = lazy(() => import('modules/users'));
const Devices = lazy(() => import('modules/devices'));
const Photos = lazy(() => import('modules/photos'));
const Complaints = lazy(() => import('modules/complaints'));
const Comments = lazy(() => import('modules/comments'));
const Areas = lazy(() => import('modules/areas'));
const AreasTable = lazy(() => import('modules/areas/components/AreasTable'));
const CreateNewArea = lazy(
  () => import('modules/areas/components/CreateNewArea')
);
const Reports = lazy(() => import('modules/reports'));

import {
  AreasPath,
  CommentsPath,
  ComplaitnsPath,
  CreateNewAreaPath,
  DashboardPath,
  DevicesPath,
  PhotosPath,
  ReportsPath,
  ReviewsPath,
  UsersPath,
} from './constants';
import { EAdmin, IRouteObject, TIndex } from './types';

export const appRoutesList: IRouteObject[] = [
  {
    role: [EAdmin.ADMIN, EAdmin.SUPER_ADMIN, EAdmin.MODERATOR],
    title: 'sidebar.dashboard',
    icon: <DashboardOutlined />,
    path: DashboardPath,
    index: true as TIndex,
    element: <Dashboard />,
  },
  {
    role: [EAdmin.ADMIN, EAdmin.SUPER_ADMIN, EAdmin.MODERATOR],
    title: 'sidebar.reviews',
    icon: <MyReviewsIcon width={16} height={16} />,
    path: ReviewsPath,
    element: <Reviews />,
  },
  {
    role: [EAdmin.ADMIN, EAdmin.SUPER_ADMIN, EAdmin.MODERATOR],
    title: 'sidebar.photos',
    icon: <PictureOutlined />,
    path: PhotosPath,
    element: <Photos />,
  },
  {
    role: [EAdmin.ADMIN, EAdmin.SUPER_ADMIN],
    title: 'sidebar.users',
    icon: <EmployeesIcon width={16} height={16} />,
    path: UsersPath,
    element: <Users />,
  },
  {
    role: [EAdmin.ADMIN, EAdmin.SUPER_ADMIN],
    title: 'sidebar.devices',
    icon: <MobileOutlined />,
    path: DevicesPath,
    element: <Devices />,
  },
  {
    role: [EAdmin.ADMIN, EAdmin.SUPER_ADMIN, EAdmin.MODERATOR],
    title: 'sidebar.complaints',
    icon: <WarningOutlined />,
    path: ComplaitnsPath,
    element: <Complaints />,
  },
  {
    role: [EAdmin.ADMIN, EAdmin.SUPER_ADMIN],
    title: 'sidebar.comments',
    icon: <CommentOutlined />,
    path: CommentsPath,
    element: <Comments />,
  },
  {
    role: [EAdmin.ADMIN, EAdmin.SUPER_ADMIN, EAdmin.MODERATOR],
    title: 'sidebar.reports',
    icon: <ReportsIcon width={16} height={16} />,
    path: ReportsPath,
    element: <Reports />,
  },
  {
    role: [EAdmin.ADMIN, EAdmin.SUPER_ADMIN],
    title: 'sidebar.areas',
    icon: <EnvironmentOutlined />,
    path: AreasPath,
    element: <Areas />,
    children: [
      {
        path: AreasPath,
        element: <AreasTable />,
      },
      {
        path: CreateNewAreaPath,
        element: <CreateNewArea />,
      },
    ],
  },
];
